export default Object.freeze({
  READ: 'read',
  UNREAD: 'unread',
  LAPSED: 'lapsed',
});
